import { Component, OnInit, Input } from '@angular/core';
import { GeometryPrimitiveValidation } from '@amdb/drone/shared/models/geometry-primitive-validation.model';
import { NbDialogRef } from '@nebular/theme';

@Component({
    templateUrl: './geometry-primitive-validation-result-list.component.html',
    styleUrls: ['./geometry-primitive-validation-result-list.component.scss'],
})
export class GeometryPrimitiveValidationResultListComponent implements OnInit {
    @Input()
    source: GeometryPrimitiveValidation[];

    @Input()
    hasGtseUuid: boolean = false;

    @Input()
    fromCoords: boolean = false;

    @Input()
    fromShp: boolean = false;

    tableSettings: any;
    loading: boolean = true;

    returnToCoordsInput: boolean = false;

    constructor(protected ref: NbDialogRef<GeometryPrimitiveValidationResultListComponent>) {}

    ngOnInit() {
        this.tableSettings = {
            mode: 'external',
            actions: false,
            pager: {
                perPage: 10,
                display: true,
            },
            columns: {
                ruleDescription: {
                    title: 'Nosacījuma apraksts',
                    filter: false,
                },
                rulePassed: {
                    title: 'Validācijas rezultāts',
                    filter: false,
                    type: 'html',
                    valuePrepareFunction: (rulePassed: boolean) => {
                        if (rulePassed === true) {
                            return `<i class="fa fa-check" aria-hidden="true"></i>`;
                        } else if (rulePassed === false) {
                            return `<i class="fa fa-times" aria-hidden="true"></i>`;
                        } else {
                            return `<span>Error</span>`;
                        }
                    },
                },
            },
        };

        this.loading = false;
        this.source.forEach(result => {
            if (!result.rulePassed) {
                this.returnToCoordsInput = true;
            }
        });
    }

    continue() {
        this.ref.close({ returnToCoordsInput: this.returnToCoordsInput });
    }

    dismiss() {
        if (!this.fromCoords) {
            this.ref.close(null);
            return;
        }

        this.ref.close({ returnToCoordsInput: true });
    }
}
